import { isPlatformBrowser } from '@angular/common';

import type { SessionStore } from './session-store';

export function expireSession(sessionStore: SessionStore, platformId: object): boolean {
  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  if (!sessionStore.beginSignOut()) {
    return false;
  }

  sessionStore.signOut();

  return true;
}
